import React from 'react';
import Markdown from 'markdown-to-jsx';
import api from 'api/blogs';
import rootActions from 'redux/rootActions';
import { Blog as BlogType } from 'types/blog';
import { Breadcrumb } from 'components/common/Breadcrumb';
import { ReadMore } from 'components/blogs/ReadMore';
import { ContentSection } from 'components/common/ContentSection';
import { GetInitialProps } from 'types/getInitialProps';
import { Layout } from 'components/common/Layout';
import { MetaTags } from 'components/meta/MetaTags';
import { NextPage } from 'next';
import { TitleHeader } from 'components/header/TitleHeader';
import { TopSection } from 'components/blogs/TopSection';
import { connect } from 'react-redux';
import Error from 'pages/_error';

interface Props {
    pathName: string;
    error?: {
        code: number;
        message: string;
    };
    blog?: BlogType;
}

const Blog: NextPage<Props> = (props) => {
    const { blog, pathName, error = null } = props;
    const { title, user, content, readMoreInfo } = blog;

    if (error) return <Error pathName={pathName} statusCode={error.code || 404} />;

    return (
        <Layout pathName={pathName}>
            <MetaTags
                title={`Werken bij Developers.nl | ${title}`}
                image="/favicons/logo_180.png"
                description="Enthousiast geworden als developer? Kom snel in contact met Developers.nl!"
                keywords="developer, developers, frontend, php, python, java, learn, code, share"
            />
            <TitleHeader title={title} />
            <Breadcrumb title={title} pathName={pathName} />

            {!error && (
                <>
                    {user.fullname && <TopSection user={user} />}

                    <ContentSection>
                        <Markdown>{content}</Markdown>
                        {readMoreInfo && <ReadMore blog={readMoreInfo} />}
                    </ContentSection>
                </>
            )}
        </Layout>
    );
};

Blog.getInitialProps = async (ctx: GetInitialProps): Promise<any> => {
    const {
        query: { slug },
        store,
    } = ctx;

    const blogSlug: string = slug.toString();
    const existingBlogs = store.getState().blogs.data || {};

    const foundBlog: any = Object.values(existingBlogs).find((blog: BlogType) => {
        return blog.slug === blogSlug;
    });

    if (foundBlog) {
        return {
            id: foundBlog.id,
            pathName: ctx.pathname,
        };
    }

    return api.oneBySlug(blogSlug).then(
        (payload) => {
            store.dispatch(rootActions.fetchBlogSuccess(payload));

            return {
                id: payload.id,
                pathName: ctx.pathname,
            };
        },
        (error) => {
            store.dispatch(rootActions.fetchBlogError(error));

            return {
                pathName: ctx.pathname,
                error: error,
            };
        },
    );
};

export default connect((state, props) => {
    const blogs = state.blogs.data || {};
    const blog = blogs[props.id] || {};

    return {
        blog: blog,
        error: state.blogs.error,
    };
}, rootActions)(Blog);
